import { BP_PANEL_CODE } from './vitals';

/**
 * LOINC codes named in code — the ones a protocol, the day view or a service branches on. Displays
 * live in the curated maps (`LOINC_LAB_DISPLAY_NAMES`, `VITAL_SIGN_CONFIGS`,
 * `LIFESTYLE_MEASUREMENT_CONFIGS`); this is only the identity, so every consumer names a code the same
 * way instead of repeating the literal.
 */
export const LOINC_CODES = {
  /** Hemoglobin A1c/Hemoglobin.total in Blood */
  HBA1C: '4548-4',
  /** Cholesterol in LDL [Mass/volume] in Serum or Plasma */
  LDL_CHOLESTEROL: '13457-7',
  /** Glucose [Mass/volume] in Blood — fingerstick / home meter */
  BLOOD_GLUCOSE: '2339-0',
  /** Blood pressure panel with all children optional */
  BLOOD_PRESSURE_PANEL: BP_PANEL_CODE,
  /** Body weight */
  BODY_WEIGHT: '29463-7',
  /** Number of steps in 24 hour Measured */
  STEPS: '41950-7',
  /** Patient Health Questionnaire 9 item (PHQ-9) total score */
  PHQ9_TOTAL_SCORE: '44261-6',
} as const;

export type LoincCode = (typeof LOINC_CODES)[keyof typeof LOINC_CODES];
